import axios from "axios";
import env from "../variables/EndpointEnvironment";

const NewsAPI = (props) => {
  return axios.get(`${env.HOST}/news?loc=${props.loc}&page=${props.page}`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default NewsAPI;
